module.exports = __webpack_public_path__ + "img/meiguo.8fb3f46f.png";